/**
 * Action Buttons renderer
 */
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { ActionButton } from '@app/shared/types/common/action-buttons.type';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'actions-button-renderer',
  templateUrl: 'actions-button-renderer.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class ActionsButtonRendererComponent {
  @Input() public status: string;
  @Input() public buttons: ActionButton[];
  @Output() public onActionBtnClicked: EventEmitter<string> =
    new EventEmitter();

  public btnClickHandler(type: string): void {
    this.onActionBtnClicked.emit(type);
  }
}
